import { ISection, ITermCourse } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
export class RequisiteCourseServant {
  getRequisitesForSection(sectionId: number, course: ITermCourse) {
    return {
      sectionId,
      courseId: course.id,
      fullTitle: `${course.cd} ${course.title}`,
      missing_coreqs: course._missing_coreqs,
      missing_prereqs: course._missing_prereqs
    };
  }

  isCoReqMissing(section: ISection) {
    return !_4.isEmpty(section._course._missing_coreqs);
  }

  isPreReqMissing(section: ISection) {
    return !_4.isEmpty(section._course._missing_prereqs);
  }
}

angular.module('capability-ng-scheduler').service('ngRequisiteCourseServant', RequisiteCourseServant);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/servants/requisite_course_servant.ts